<arm-dialog (onCancel)="cancel()"
            (onSubmit)="submit()"
            [disabled]="!mapForm.form.valid || !portControl.valid"
            class="snmp-destination-dialog"
            [title]="(data.isEditMode ? 'Edit' : 'Add')+ ' SNMP DESTINATION'">

  <form #mapForm="ngForm" autocomplete="off">
    <mat-form-field  class="fullWidth">
      <mat-label>Host</mat-label>
      <input matInput required [(ngModel)]="data.selectedItem.host" name="host">
      <mat-error>
        Host is <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="fullWidth">
      <mat-label>Port</mat-label>
      <input matInput [(ngModel)]="data.selectedItem.port" type="number" min="1"
             max="65535" name="port" [formControl]="portControl" required>
      <mat-error>
        <strong>Invalid</strong> port
      </mat-error>
    </mat-form-field>

    <mat-form-field  class="fullWidth">
      <mat-label>Community</mat-label>
      <input matInput required [(ngModel)]="data.selectedItem.community" name="community">
      <mat-error>
        Community is <strong>required</strong>
      </mat-error>
    </mat-form-field>
    <mat-checkbox name="isKeepAlive_checkbox" color="primary" class="fullWidth"
                  [(ngModel)]="data.selectedItem.isKeepAlive">
      ARM keep-alive
    </mat-checkbox>
    <ac-line-separator separatorId="aim-seperator" title="AudioCodes Intelligent Monitoring"></ac-line-separator>

    <mat-checkbox name="isAIM_checkbox" color="primary" class="fullWidth isAIM-checkbox"
                  [(ngModel)]="data.selectedItem.isAIM">
      Enable
    </mat-checkbox>
    <mat-form-field class="fullWidth">
      <mat-label>Device description</mat-label>
      <input matInput [disabled]="!data.selectedItem.isAIM" [(ngModel)]="data.selectedItem.deviceDescription"
             name="deviceDescription">
    </mat-form-field>

  </form>
</arm-dialog>
